import { element } from 'angular';
export var ViewFavouritesDirective = [
    '$rootScope',
    'favouritesService',
    function ($rootScope, favouritesService) {
        var activeClass = 'active';
        var disabledClass = 'disabled';
        return {
            link: function ($scope, $element) {
                var isDisabled = false;
                $element.on('click', '.view-favourites__button, .view-favourites__icon', function (clickEvent) {
                    if (isDisabled) {
                        $rootScope.$broadcast('favourites:fullhide');
                        return;
                    }
                    if (!$element.hasClass(activeClass)) {
                        $scope.favourites = favouritesService.getFavourites();
                        $scope.$apply();
                    }
                    $element.toggleClass(activeClass);
                    clickEvent.stopPropagation();
                });
                $element.on('click', '.close', function () {
                    $element.removeClass(activeClass);
                });
                $scope.$on('$destroy', function () {
                    $element.removeClass(activeClass);
                    $element.off('click');
                });
                $scope.favourites = favouritesService.getFavourites();
                element('body').on('click', function (clickEvent) {
                    if (element(clickEvent.target).closest('view-favourites').length !== 0) {
                        return;
                    }
                    $element.removeClass(activeClass);
                });
                $rootScope.$on('favourites:changed', function (event, favourites) {
                    $scope.favourites = favourites;
                });
                $rootScope.$on('favourites:fullshown', function () {
                    isDisabled = true;
                    $element.addClass(disabledClass);
                });
                $rootScope.$on('favourites:fullhidden', function () {
                    isDisabled = false;
                    $element.removeClass(disabledClass);
                });
                $scope.remove = function (pageUrl) {
                    favouritesService.remove(pageUrl);
                };
            },
            restrict: 'E',
            templateUrl: 'compatibilityguide/ng-templates/feature/favourites/viewfavourites',
        };
    },
];
